import React, { cloneElement } from 'react';
import { CheckCircleIcon, CircularLoaderIcon } from '@/icons';
import { cn } from '@/utils/mergeClassName';

type Status = 'loading' | 'success';

type FormStatusProps = {
  status: Status;
  title: string | React.ReactNode;
  content?: React.ReactNode;
  className?: string;
};

const getStatusContent = {
  loading: () => (
    <div role="status">
      <CircularLoaderIcon className="size-[10.5rem] animate-spin xl:size-56" />
      <span className="sr-only">Carregando...</span>
    </div>
  ),
  success: () => (
    <div role="status">
      <CheckCircleIcon className="size-[10.5rem] xl:size-56" />
    </div>
  )
};

export const FormStatus = ({ status, title, content, className }: FormStatusProps) => {
  const Title = () => {
    if (typeof title === 'string') {
      return (
        <h2 className="font-publico text-2xl font-bold text-blue-500 xl:text-[2rem] xl:leading-10">
          {title}
        </h2>
      );
    }

    return cloneElement(title as any, {
      className: 'font-publico text-2xl font-bold text-blue-500 xl:text-[2rem] xl:leading-10'
    });
  };

  return (
    <div
      className={cn(
        'z-[1] grid h-full min-h-[calc(100vh_-_120px)] w-full grid-rows-[auto_1fr] gap-10 bg-white lg:grid-cols-2 lg:grid-rows-1 lg:gap-0 xl:h-[calc(100vh_-_128px)]',
        className
      )}
    >
      <div className="px-6 pt-12 lg:px-12 lg:py-20 3xl:px-[7.5rem]">
        <Title />
        {content}
      </div>
      <div className="flex items-center justify-center pb-4">{getStatusContent[status]()}</div>
    </div>
  );
};
